module.exports = __webpack_public_path__ + "static/syntelliu-545fe0d76c86217b5c7c9385b94b5a60.png";